/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import axios from 'axios';
import { Box, Button, Typography, CircularProgress } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const serverUrl = process.env.SERVER_URL ?? 'http://localhost:3000';

const VerifyEmailChange: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const location = useLocation();

  useEffect(() => {
    const verifyEmailChange = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');
      if (token) {
        try {
          const response = await axios.get(
            `${serverUrl}/api/user/verify-email-change/${token}`,
          );
          if (response.status === 200) {
            // Verification successful
            setLoading(false);
          }
        } catch (err: any) {
          // Handle verification error
          setError(true);
          setLoading(false);
        }
      } else {
        // No token provided
        setError(true);
        setLoading(false);
      }
    };

    verifyEmailChange();
  }, [location]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
    >
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Box textAlign="center">
          <ErrorOutlineIcon color="error" fontSize="large" />
          <Typography variant="h5" color="error">
            Verification failed. Please try again.
          </Typography>
        </Box>
      ) : (
        <Box textAlign="center">
          <CheckCircleOutlineIcon color="success" fontSize="large" />
          <Typography variant="h5">
            Your email has been successfully updated!
          </Typography>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/login"
          >
            Continue to Login
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default VerifyEmailChange;
